module.exports = __webpack_public_path__ + "static/img/09.509ffe02.png";